import videojs from "video.js";
import("videojs-contrib-quality-levels");

const MenuButton = videojs.getComponent("MenuButton");

class QualitySelectorButton extends MenuButton {
  constructor(player, options) {
    super(player, options);
    this.automaticQuality = useRuntimeConfig().public.VUE_APP_AUTO_QUALITY_VIDEO;
    this.selectedQuality = null;
    this.qualityLevels = [];
    //this.menuButton_ = this.el().querySelector('button.vjs-quality-menu-button');

    /*player.on('loadedmetadata', () => {*/
    this.qualityLevels = player.qualityLevels();
    this.autoQualityLevel(options.maximumDefaultQuality || {});
    /*});*/
  }

  set qualityLevels(qualityLevels) {
    this.qualityLevels_ = qualityLevels;

    this.updateQualityLevelsDom();
  }

  get qualityLevels() {
    return this.qualityLevels_;
  }

  updateQualityLevelsDom() {
    let vjsMenuItem = document.createElement("div");
    let vjsMenuItemUl = document.createElement("ul");

    vjsMenuItem.classList.add("vjs-menu");
    vjsMenuItem.appendChild(vjsMenuItemUl);
    vjsMenuItemUl.classList.add("quality_ul", "vjs-menu-content");

    for (let i = 0; i < this.qualityLevels.length; i++) {
      let qualityLevel = this.qualityLevels[i];

      let listItem = document.createElement("li");
      listItem.classList.add("vjs-menu-item");

      let qualityName = "Calidad X";

      if (qualityLevel.height !== undefined) {
        let extraText = "";

        /*
                switch(qualityLevel.height){
                    case 1080: extraText = 'FullHD'; break;
                    case 720: extraText = 'HD'; break;
                    case 480: extraText = 'SD'; break;
                }*/

        qualityName = `${qualityLevel.height}p ${extraText}`;
      } else if (qualityLevel.bitrate !== undefined) {
        qualityName = `Bitrate: ${qualityLevel.bitrate}`;
      }

      listItem.appendChild(document.createTextNode(qualityName));

      if (this.selectedQuality == qualityLevel) {
        listItem.classList.add("vjs-selected");
      }

      listItem.addEventListener("click", (event) => {
        this.setSingleQualityLevel(i);
        this.el().classList.remove("active");
      });

      vjsMenuItemUl.appendChild(listItem);
    }

    let autoListItem = document.createElement("li");
    autoListItem.classList.add("vjs-menu-item");
    autoListItem.appendChild(document.createTextNode(`Auto`));

    if (this.automaticQuality) {
      autoListItem.classList.add("vjs-selected");
    }

    autoListItem.addEventListener("click", (event) => {
      this.autoQualityLevel();
      this.el().classList.remove("active");
    });

    vjsMenuItemUl.appendChild(autoListItem);

    let oldQualitySelector = this.el().querySelector(".vjs-menu");
    if (oldQualitySelector) {
      oldQualitySelector.remove();
    }
    this.el().appendChild(vjsMenuItem);
  }

  autoQualityLevel(maximum) {
    if (maximum === undefined) {
      maximum = {};
    }

    // let allEnabled = true;

    for (let i = 0; i < this.qualityLevels.length; i++) {
      let enabled = true;

      if (
        (maximum.bitrate !== undefined &&
          this.qualityLevels[i].bitrate !== undefined &&
          this.qualityLevels[i].bitrate > maximum.bitrate) ||
        (maximum.height !== undefined &&
          this.qualityLevels[i].height !== undefined &&
          this.qualityLevels[i].height > maximum.height) ||
        (maximum.width !== undefined &&
          this.qualityLevels[i].width !== undefined &&
          this.qualityLevels[i].width > maximum.width)
      ) {
        enabled = false;
        // allEnabled = false;
      }

      this.qualityLevels[i].enabled = enabled;
    }

    // if (allEnabled) {
    //   this.automaticQuality = true;
    // }

    this.selectedQuality = null;

    this.updateQualityLevelsDom();
  }

  setSingleQualityLevel(selectedIndex) {
    this.automaticQuality = false;
    this.selectedQuality = this.qualityLevels[selectedIndex];

    for (let i = 0; i < this.qualityLevels.length; i++) {
      this.qualityLevels[i].enabled = i === selectedIndex;
    }

    this.updateQualityLevelsDom();
  }

  buildCSSClass() {
    return `vjs-icon-cog vjs-menu-button vjs-quality-menu-button vjs-menu-button-popup ${super.buildCSSClass()}`;
  }

  handleClick() {
    super.handleClick();

    if (this.el().classList.contains("active")) {
      this.el().classList.remove("active");
    } else {
      this.el().classList.add("active");
    }

    /*

        console.log(this.el().querySelector('button.vjs-quality-menu-button'));

        */
  }
}

QualitySelectorButton.prototype.controlText_ = "";

videojs.registerComponent("QualitySelectorButton", QualitySelectorButton);

const QualitySelector = function (options) {
  this.on("loadeddata", function () {
    if (
      this.controlBar.el().querySelector(".vjs-quality-menu-button") !== null ||
      this.controlBar.fullscreenToggle === undefined
    )
      return;

    let toggle = this.controlBar.addChild("QualitySelectorButton", options);
    this.controlBar
      .el()
      .insertBefore(toggle.el(), this.controlBar.fullscreenToggle.el());
  });
};

videojs.registerPlugin("QualitySelector", QualitySelector);
